module.exports = __webpack_public_path__ + "static/media/AppleVendor.6930fe39.png";